import { axiosGet } from 'shared/api/axios'

const getOne = async (url: string, id?: number | string | undefined, extend?: string[]) => {

  let route = url

  if (typeof id !== 'undefined')
    route += '/' + id

  const response = await axiosGet(
    route + (extend !== undefined ? '?expand=' + extend.join(',') : ''),
  )

  return response.data
}

export default getOne
